import { Box } from "@mui/material";

/** The id every page's <main> landmark carries. */
import { jsx as _jsx } from "react/jsx-runtime";
export const MAIN_CONTENT_ID = "main-content";

/**
 * "Skip to main content" — WCAG 2.4.1 Bypass Blocks.
 *
 * The site has no skip link and no landmark, so a keyboard or screen
 * reader user had to tab through the entire navigation (logo, six section
 * links, search, account menu) on EVERY page before reaching content.
 *
 * It is the first focusable element in the DOM and is visually hidden
 * until focused — clipped rather than `display: none`, because a
 * display-hidden element cannot receive focus at all.
 */
export default function SkipLink() {
  return /*#__PURE__*/_jsx(Box, {
    component: "a",
    href: `#${MAIN_CONTENT_ID}`,
    sx: {
      position: "absolute",
      left: 8,
      top: 8,
      zIndex: theme => theme.zIndex.tooltip + 1,
      px: 2,
      py: 1,
      borderRadius: 1,
      bgcolor: "background.paper",
      color: "text.primary",
      fontWeight: 600,
      textDecoration: "none",
      boxShadow: 6,
      // Clipped out of view until focused; still in the a11y tree.
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: 1,
      width: 1,
      overflow: "hidden",
      whiteSpace: "nowrap",
      "&:focus, &:focus-visible": {
        clip: "auto",
        clipPath: "none",
        height: "auto",
        width: "auto",
        overflow: "visible",
        outline: "2px solid currentColor",
        outlineOffset: 2
      }
    },
    children: "Skip to main content"
  });
}